export class CultureDataFormatter {

	public static parseInteger(val: string): number {
    if(!val){
      return 0;
    }

		const start = val.indexOf("[I:");
		const end = val.indexOf("]");

    // check string do not contains '[I:' nor ']'
    if (start === -1 && end === -1) {
			return parseInt(val, 10);
		}

    // check string do not contains any of '[I:' and ']'
		if (start === -1 || end === -1) {
			return 0;
		}

		return parseInt(val.substring(start + 3, end), 10);
	}

  public static parseDate(val: string): string {
    if (!(val && val.indexOf)) {
      return val;
    }

    const start = val.indexOf("[D:");
		const end = val.indexOf("]");

    // check string do not contains '[D:' nor ']'
    if (start === -1 && end === -1) {
			return this.parseDateOnly(val, 0, val.length);
		}

    // check string do not contains any of '[D:' and ']'
		if (start === -1 || end === -1) {
			return val;
		}

    if (val.indexOf("[D:") === 0) {
        return this.parseDateOnly(val, start + 3, end);
    }
  }

  private static parseDateOnly(val: string, start: number, end: number): string {
    let date = val.substring(start, end); // "[D:10/19/2023 00:00:00.0000000]" --> "D:10/19/2023 00:00:00.0000000"
    const idxTimeSeparator = date.indexOf(" ");
    const containsTime = idxTimeSeparator !== -1 && idxTimeSeparator > 8;
    if (containsTime) {
      date = date.substring(0, idxTimeSeparator); // "10/19/2023 00:00:00.0000000" --> "10/19/2023"
    }
    return date;
  }
}
